export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.16-0855.15",
  commitId: "fd8d4323010ed3ca126e17666594db3ebf132a02",
  commitTime: "2026-07-16T08:55:15.000Z",
});
